@if (data()?.pictureURL?.length > 0 && !displayDefaultAvatar()) {
  <img alt="avatar" fill placeholder [ngSrc]="data().pictureURL" (error)="onError()" />
} @else {
  <span [title]="data().fullname">
    {{ data().abbreviation }}
  </span>
}
